import React, {useMemo} from 'react';
import {LandingPageContent} from '@/constants';
import {useWindowDimensions} from '@/hooks';
import {flatten} from 'ramda';

interface ComplainceProps {
  id?: string;
}
export const Complaince: React.FC<ComplainceProps> = ({id}) => {
  const {width} = useWindowDimensions();
  const issmall = width < 1024;
  const mappingData = useMemo(() => {
    if (issmall) {
      return flatten(LandingPageContent.security.card).map(item => [item]);
    }
    return LandingPageContent.security.card;
  }, [issmall]);

  return (
    <div id={id} className="items-center flex flex-col pt-0 md:pt-2 pb-6 md:pb-8 -mt-6 md:-mt-8">
      <h2
        id="gradient-text-2"
        className="items-center py-10 text-3xl md:text-4xl 2xl:text-5xl font-FigtreeBold">
        {LandingPageContent.security.title}
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 2xl:flex gap-4 md:gap-10 items-center px-2 sm:px-4">
        {mappingData.map((item, index) => (
          <div
            className="flex flex-col gap-2 md:gap-6 grow h-full 2xl:h-fit"
            key={index}>
            {item.map(card => (
              <div
                style={{boxShadow: '0px 0px 48px 10px #D2EAEF99'}}
                key={card.title}
                className={`flex h-full 2xl:h-fit flex-col gap-3 p-4 sm:p-6 md:p-8 lg:p-10 rounded-3xl max-w-[340px] sm:max-w-[400px] w-full min-h-[180px] sm:min-h-0`}>
                <div className="flex items-center justify-center gap-2 sm:gap-4 flex-wrap">
                  <img
                    alt={`${card.title} icon`}
                    src={card.image}
                    className="size-[30px] object-contain flex-shrink-0"
                  />

                  <h3 className="sm:whitespace-nowrap 2xl:whitespace-pre-line font-FigtreeExtraBold text-ui_blue text-center transition-all duration-[0.2s] text-xl sm:text-xl lg:text-2xl 2xl:text-3xl hover:scale-110 break-words">
                    {card.title}
                  </h3>
                </div>
                <p className=" mt-3 text-center opacity-80 text-lg sm:text-base md:text-xl 2xl:text-2xl font-FigtreeMeduim text-ui_blue break-words">
                  {card.description}
                </p>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
